/**
 * @format
 * @flow
 */
import axios from 'axios';
import * as Template from '../constants/reducers/Template';
import * as Api from '../constants/Api';
import {loadStart, loadEnd, modalOpen} from './App';


//TEMPLATE
export const postTemplate = (searchArgs,token) => {
    return dispatch => {
        dispatch(loadStart());
        axios
            .post(
                Api.postTemplateApi,
                {
                    code: "set_template",
                    ...searchArgs,
                },
                {
                    headers: { Authorization: token }
                }
            )
            .then(res => {
                // eslint-disable-next-line no-param-reassign
                res = JSON.parse(res.data.body);
                if ('errorMessage' in res) {
                    dispatch(modalOpen(res.errorMessage, '失敗'));
                } else {
                    dispatch(saveTemplate(res.data));
                }
                dispatch(loadEnd());
            })
            .catch(() => {
                dispatch(loadEnd());
            });
    };
};

export const getTemplateData = (body,token) => {
    return dispatch => {
        dispatch(loadStart());
        axios
            .post(
                Api.postTemplateApi,
                {
                    code: "get_template",
                    ...body,
                },
                {
                    headers: { Authorization: token }
                }
            )
            .then(res => {
                res = JSON.parse(res.data.body);
                console.log('支払情報取得！', res);
                if ('errorMessage' in res) {
                    dispatch(loadEnd());
                } else {
                    dispatch(getTemplate(res.data));
                }
                dispatch(loadEnd());
            })
            .catch(err => {
                console.log('エラーです');
                console.log(err);
                dispatch(loadEnd());
            });
    };
}

export const deleteTemplate = (body,token) => {
    return dispatch => {
        dispatch(loadStart());
        axios
            .post(
                Api.postTemplateApi,
                {
                    code: "delete_template",
                    ...body,
                },
                {
                    headers: { Authorization: token }
                }
            )
            .then(res => {
                res = JSON.parse(res.data.body);
                console.log('支払情報取得！', res);
                if ('errorMessage' in res) {
                    dispatch(loadEnd());
                } else {
                    dispatch(deleteTemplateData(true));
                }
                dispatch(loadEnd());
            })
            .catch(err => {
                console.log('エラーです');
                console.log(err);
                dispatch(loadEnd());
            });
    };
}

export const getTemplateId = (body,token) => {
    return dispatch => {
        dispatch(loadStart());
        axios
            .post(
                Api.postTemplateApi,
                {
                    code: "get_template",
                    ...body,
                },
                {
                    headers: { Authorization: token }
                }
            )
            .then(res => {
                res = JSON.parse(res.data.body);
                console.log('支払情報取得！', res);
                if ('errorMessage' in res) {
                    dispatch(loadEnd());
                } else {
                    dispatch(getTemplateIdData(res.data));
                }
                dispatch(loadEnd());
            })
            .catch(err => {
                console.log('エラーです');
                console.log(err);
                dispatch(loadEnd());
            });
    };
}

export const editTemplate = (searchArgs,token) => {
    return dispatch => {
        dispatch(loadStart());
        axios
            .post(
                Api.postTemplateApi,
                {
                    code: "update_template",
                    ...searchArgs,
                },
                {
                    headers: { Authorization: token }
                }
            )
            .then(res => {
                res = JSON.parse(res.data.body);
                console.log('支払情報取得！', res);
                if ('errorMessage' in res) {
                    dispatch(loadEnd());
                } else {
                    dispatch(editTemplateData(true));
                }
                dispatch(loadEnd());
            })
            .catch(err => {
                console.log('エラーです');
                console.log(err);
                dispatch(loadEnd());
            });
    };
};


export const saveTemplate = data => {
    return {
        type: Template.POST_TEMPLATE,
        data
    };
}

export const getTemplate = data => {
    return {
        type: Template.GET_TEMPLATE,
        data
    };
}

export const getTemplateIdData = data => {
    return {
        type: Template.GET_TEMPLATE_ID,
        data
    };
}

export const editTemplateData = data => {
    return {
        type: Template.EDIT_TEMPLATE,
        data
    };
}

export const reseTemplate = () => {
    return {
        type: Template.RESET_TEMPLATE,
    };
}

export const deleteTemplateData = data => {
    return {
        type: Template.DELETE_TEMPLATE,
        data
    };
}

export const resetDeleteTemplateData = () => {
    return {
        type: Template.RESET_DELETE_TEMPLATE,
    };
}

